module.exports = __webpack_public_path__ + "img/twittericon.c8ec512f.svg";